export class AppConfig {
  public readonly serverUrl: string;
  public readonly webrtcRetryAttempts: number;
  public readonly webrtcRetryDelaySeconds: number;
  public readonly splashScreenDurationSeconds: number;
  public readonly debugMessageMaxLength: number;
  public readonly betterStackSourceToken: string;
  public readonly betterStackLogLevel: string;

  constructor() {
    // Default to the same host as the current page, but on port 3000
    const defaultServerUrl = typeof window !== 'undefined' 
      ? `${window.location.protocol}//${window.location.hostname}:3000`
      : 'http://localhost:3000';
    
    this.serverUrl = import.meta.env.VITE_SERVER_URL || defaultServerUrl;
    this.webrtcRetryAttempts = parseInt(import.meta.env.VITE_WEBRTC_RETRY_ATTEMPTS || '5', 10);
    this.webrtcRetryDelaySeconds = parseFloat(import.meta.env.VITE_WEBRTC_RETRY_DELAY_SECONDS || '2');
    this.splashScreenDurationSeconds = parseFloat(import.meta.env.VITE_SPLASH_DURATION_SECONDS || '3');
    this.debugMessageMaxLength = parseInt(import.meta.env.VITE_DEBUG_MESSAGE_MAX_LENGTH || '200', 10);
    this.betterStackSourceToken = import.meta.env.VITE_BETTERSTACK_SOURCE_TOKEN || '';
    this.betterStackLogLevel = import.meta.env.VITE_BETTERSTACK_LOG_LEVEL || 'error';
  }
}

export const appConfig = new AppConfig();
